import { defineComponent, openBlock, createElementBlock, createElementVNode, toDisplayString, createVNode, unref, withCtx, createTextVNode } from "vue";
import { CdrButton } from "@rei/cedar";
const _hoisted_1 = {
  class: "buy-box-pup"
};
const _hoisted_2 = {
  class: "buy-box-pup__msg-text"
};
const _hoisted_3 = {
  class: "buy-box-pup__description-text"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxPup",
  props: {
    description: {},
    messageText: {},
    ctaText: {},
    href: {}
  },
  emits: ["metricsClick"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("p", _hoisted_2, toDisplayString(_ctx.messageText), 1), createElementVNode("p", _hoisted_3, toDisplayString(_ctx.description), 1), createVNode(unref(CdrButton), {
        id: "lucky-pup-redirect-button",
        "full-width": true,
        tag: "a",
        href: _ctx.href,
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("metricsClick", {
          linkName: _ctx.ctaText
        }))
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.ctaText), 1)]),
        _: 1
      }, 8, ["href"])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxPup2.mjs.map
